<template>
  <b-field
    :label="label"
    :type="hasError() ? 'is-danger': ''"
    :message="errorMessage()"
  >
    <b-input
      v-model="currentValue"
      :placeholder="placeholder"
      :icon="icon"
      :disabled="disabled"
      :class="{'is-danger': hasError()}"
    />
  </b-field>
</template>

<script>
import Cleave from "cleave.js";
import InputBase from "./InputBase";

export default {
  extends: InputBase,
  props: {
    value: {
      required: true,
      validator: prop => _.isString(prop) || _.isNumber(prop) || prop === null
    },
    icon: {
      default: null,
      type: String
    },
    disabled: {
      default: false,
      type: Boolean
    },
    mask: {
      required: true,
      type: Object
    }
  },
  data() {
    return {
      currentValue: this.value,
    };
  },
  watch: {
    value () {
      this.setValue();
    }
  },
  mounted() {
    let options = this.mask;
    options.onValueChanged = this.onValueChanged;
    this.cleave = new Cleave(this.$el.querySelector("input"), options);
    this.setValue();
  },
  methods: {
    setValue() {
      this.cleave.setRawValue(this.value);
    },
    onValueChanged({ target }) {
      this.$nextTick(() => {
        this.currentValue = target.value;
        this.inputListener(target.rawValue);
      });
    },
  }
};
</script>
